import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AppIntroService } from 'src/app/layout/components/app-intro/app-intro.service';

@Injectable()
export class ClientDataGuard  {

  constructor(
    private appIntroService: AppIntroService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    
    return true;
  }

}
